export default "/_next/static/chunks/fonts/Syne Extra-44a66f698753202e8e74bad212023777.otf";